import { Protocol } from '../Protocol';

export class SpecificationProtocol {
  public static readonly SPECIFICATION_URL: string = `${Protocol.YATUNG_API_ROOT}/specification`; // 更新 && 新增規格
  public static readonly ALL_SPECIFICATIONS: string = `${Protocol.YATUNG_API_ROOT}/specification/all`;
  public static readonly ALL_SPECIFICATION_COST: string = `${Protocol.YATUNG_API_ROOT}/specification/cost/all`;
  public static readonly CHEM_TYPE_SPECIFICATION: string = `${Protocol.YATUNG_API_ROOT}/specification/attr-type-code`;
  public static readonly GET_SPECIFICATION_BY_CODE: string = `${Protocol.YATUNG_URL}/specification/expt-item-code`;
}
